/**
 * Created by Santiago on 12/6/17.
 */
export default {
    shareScreen: "Deseja compartilhar a tela?",
    no: 'Não',
    yes: 'Sim',
    youmustpickastar: 'Você deve escolher um grau',
    name: 'Nome',
    email: 'Correio eletrônico',
    phone: 'Telefone',
    message: 'Mensagem',
    sendMessage: 'Enviar mensagem',
    newConversation: 'Nova conversa',
    sendpunctuation: "Enviar classificação",
    musttypemail: 'Você deve inserir seu e-mail',
    validemail: 'Não é um e-mail válido',
    musttypename: 'Você deve digitar seu nome',
    musttypemessage: 'Você deve escrever uma mensagem',
    configuration: 'Configuração',
    notifications: 'Notificações',
    screenshare: "Compartilhar tela",
    notificationDetails: 'Notificar-me sobre novas mensagens que recebo nesta conversa',
    close: 'Fechar',
    cancel: 'Cancelar',
    save: 'Guardar',
    willclose: 'Encerramento da conversa',
    closeconf: 'Tem certeza de que deseja encerrar a conversa?',
    conversationend: 'A conversa terminou, você deseja fechá-la?',
    newmessage: 'Nova mensagem',
    typehere: 'Envie uma mensagem ...',
    whatdoyouthink: 'O que você acha do serviço prestado?',
    sendbymail: 'Enviar conversa por e-mail',
    holdtimeavg: 'Tempo médio de espera',
    holdtime: 'Seu tempo de espera',
    messagesended: 'Mensagem enviada',
    emailerror: "Você deve inserir um e-mail válido para continuar",
    fieldserror: "Verifique os campos e tente novamente",
    messageserror: 'Ops, algo deu errado :(',
    message: 'Escreva sua mensagem...',
    transfering: 'Transferindo...',
    endchat: 'Fim de papo',
    videocall: 'Video chamada',
    call: 'Chamada',
    openinextarnalwindow: 'Abrir na janela externa',
    calling: 'Ligando',
    callingduration: 'Duraçao da chamada',
    mute: 'Mute',
    allowmicrophone: 'Permitir o microfone',
    hangup: 'Aguentar',
    callonhold: 'Chamada em espera',
    duration: 'Duração',
    write: 'Escrever',
    survey_title: 'Esperamos tê-lo ajudado',
    survey_desc: 'Agradecemos que você reserve um tempo para nos dizer o que pensa do serviço prestado, esses dados nos ajudam a continuar fornecendo um serviço ideal!',
    available: "Disponível",
    invalidextension: "Formato de anexo inválido",
    maxfilesize10mb: "Tamanho máximo do arquivo 10 MB",
    accessibility: "Acessibilidade",
    accessibilityMenu: "Menu de acessibilidade",
    "Font size": "Tamanho da fonte",
    emojis: {
        search: "Pesquisar",
        notfound: "Nenhum Emoji Encontrado",
        title: "Escolha um Emoji",
        categories: {
            search: "Resultados da Pesquisa",
            recent: "Usados ​​Recentemente",
            people: "Rostos e Pessoas",
            nature: "Animais e Natureza",
            foods: "Comida e Bebida",
            activity: "Atividade",
            places: "Viagens e Lugares",
            objects: "Objetos",
            symbols: "Símbolos",
            flags: "Bandeiras",
            custom: "Personalizados",
        },
    },
};